import React from 'react'

const Contact = () => {
  return (
    <div name="contact" className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
      <form method="POST" action="https://getform.io/f/3fc19a22-d723-4cab-834b-cd40a407134a" className='flex flex-col max-w-[600px] w-full'>
        <div className='pb-2'>
            <p className='text-4xl font-bold inline border-b-4 bordr-pink-600 text-gray-300'>
                Contact
            </p>
            <p className='text-gray-300 py-4'>Submit the form below or shoot me an email - poonam.soni.adlakha@gmail.com</p>
        </div>
        <input className="my-4 p-2 bg-[#ccd6f6]" type="text" placeholder="Name" />
        <input className="my-4 p-2 bg-[#ccd6f6]" type="email" placeholder="Email" name='email'/>
        <textarea className='bg-[#ccd6f6] p-2' name='message' rows="10" placeholder="Message"></textarea>
        <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
      </form>
    </div>
  )
}

export default Contact
